import I18nPlugin from './index';

export function install(app, options = {}) {
    const i18n = new I18nPlugin(options);

    app.config.globalProperties.$icu = function (key, ...values) {
        return i18n._icu(key, i18n.locale, i18n._getMessages(), ...values);
    };

    app.config.globalProperties.$msg = function (key, ...values) {
        return i18n._msg(key, i18n.locale, i18n._getMessages(), ...values);
    };

    app.config.globalProperties.$requireMsg = function (keyPattern) {
        return i18n.requireMsg(keyPattern);
    };

    app.config.globalProperties.$d = function (value, ...args) {
        return i18n.d(value, ...args);
    };

    app.config.globalProperties.$dt = function (value, ...args) {
        return i18n.dt(value, ...args);
    };

    app.config.globalProperties.$n = function (value, ...args) {
        return i18n.n(value, ...args);
    };
}

export function createInstallFunction(options) {
    return (app, pluginOptions) => install(app, {...options, ...pluginOptions});
}
